import Vue from 'vue';
import { Component, Inject, Prop, Emit } from 'vue-property-decorator';
import { Availability } from '@/models/availability';

@Component
export default class TimesheetHeader extends Vue {
  @Prop({ default: [] })
  private days: Availability[];
}
